<template>
  <div class="procedure-status d-flex flex-row align-items-center">
    <div v-if="!type || type === 'procedure'" class="circle" :class="status | colorProcedureStatus"></div>
    <div v-else-if="type === 'payment'" class="circle" :class="status | colorPaymentStatus"></div>
    <div v-else-if="type === 'document'" class="circle" :class="status | colorDocumentStatus"></div>
    {{ status }}
  </div>
</template>

<script>
  export default {
    name: "CircleStatus",
    props: ['status', 'type']
  }
</script>

<style lang="scss" scoped>
  .procedure-status {
    .circle {
      border-radius: 50%;
      width: 13px;
      height: 13px;
      margin-right: 1rem;
      background-color: $gray;

      &.green {
        background-color: $green;
      }

      &.red {
        background-color: $red;
      }

      &.orange {
        background-color: $orange;
      }

      &.blue {
        background-color: $brand-secondary;
      }
    }
  }
</style>
